import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import MobileSubNavigator from '../../components/MobileSubNavigator';
import { useLocation, useNavigate } from 'react-router-dom';

const staticLinks = [
  { path: "/User/Board/usermaster", label: "전체 리스트" },
  { path: "/User/Board/reference_statistics", label: "추천인-통계" },
  { path: "/User/Board/partnerlist", label: "파트너 리스트" },
  { path: "/User/Board/identity_auth", label: "신분 인증 리스트" }
];

const MobileUser = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [links, setLinks] = useState([]);

  useEffect(() => {
    console.log('=== MobileUser useEffect 실행됨 ===');
    // API 호출하여 테이블 이름 가져오기 (PC 버전과 동일)
    const fetchBoardTables = async () => {
      try {
        console.log('=== MobileUser fetchBoardTables 시작 ===');
        const response = await fetch('/request/getBoardTables?category=User', { 
          credentials: 'include',
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          }
        });
        
        if (!response.ok) {
          console.error(`HTTP Error: ${response.status} - ${response.statusText}`);
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        
        const data = await response.json();
        console.log('받은 데이터:', data);

        // 서버에서 배열을 직접 반환하므로 그대로 사용
        let dynamicLinks = [];
        if (Array.isArray(data)) {
          dynamicLinks = data.map(table => ({
            path: `/User/Board/${table.boardId}`,
            label: table.boardTitle
          }));
        }

        console.log('생성된 동적 링크들:', dynamicLinks);
        
        // 정적 링크와 동적 링크 결합
        const combinedLinks = [...staticLinks, ...dynamicLinks];
        console.log('최종 combined links:', combinedLinks);
        setLinks([]);
        setTimeout(() => {
          setLinks(combinedLinks);
        }, 100);
      } catch (error) {
        console.error('Error fetching board tables:', error);
        console.log('에러 발생, staticLinks 적용:', staticLinks);
        setLinks(staticLinks);
      }
    };

    fetchBoardTables();
  }, []);

  useEffect(() => {
    if (links.length > 0) {
      if (location?.state?.fromNavigator === true) {
        navigate(links[0].path);
      }
    }
  }, [location, links, navigate]);

  
  return (
    <MobileSubNavigator 
      links={links} 
      sectionTitle="사용자 관리"
      backPath="/"
    >
      <Outlet context={{ links }} />
    </MobileSubNavigator>
  );
};

export default MobileUser;